import React from 'react';

interface DNAHelixIconProps {
  className?: string;
  size?: number;
}

export const DNAHelixIcon: React.FC<DNAHelixIconProps> = ({ className, size = 36 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    width={size}
    height={size}
    className={className}
  >
    <path d="M8 3 C8 8, 24 10, 24 16 C24 22, 8 24, 8 29" stroke="#2dd4a0" strokeWidth="2.2" />
    <path d="M24 3 C24 8, 8 10, 8 16 C8 22, 24 24, 24 29" stroke="#38bdf8" strokeWidth="2.2" />
    <line x1="11" y1="7" x2="21" y2="7" stroke="#2dd4a0" strokeWidth="1.4" opacity="0.6" />
    <line x1="9" y1="13" x2="23" y2="13" stroke="#38bdf8" strokeWidth="1.4" opacity="0.6" />
    <line x1="9" y1="19" x2="23" y2="19" stroke="#2dd4a0" strokeWidth="1.4" opacity="0.6" />
    <line x1="11" y1="25" x2="21" y2="25" stroke="#38bdf8" strokeWidth="1.4" opacity="0.6" />
  </svg>
);

interface LogoProps {
  className?: string;
  iconSize?: number;
  variant?: 'full' | 'icon';
}

export const Logo: React.FC<LogoProps> = ({ className, iconSize = 32, variant = 'full' }) => {
  if (variant === 'icon') {
    return <DNAHelixIcon size={iconSize} className={className} />;
  }

  return (
    <div className={`flex items-center gap-2.5 ${className ?? ''}`}>
      <DNAHelixIcon size={iconSize} />
      <span className="font-heading text-xl font-semibold tracking-wide text-white">
        Mendl Labs
      </span>
    </div>
  );
};
